import React from "react";

const SupportIcon = ({ color = "#1C274C" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 3C7.58 3 4 6.13 4 10C4 12.38 5.19 14.47 7 15.74V19C7 19.55 7.45 20 8 20H9.5C9.78 20 10 19.78 10 19.5V17H14V19.5C14 19.78 14.22 20 14.5 20H16C16.55 20 17 19.55 17 19V15.74C18.81 14.47 20 12.38 20 10C20 6.13 16.42 3 12 3ZM8.5 11.5C7.67 11.5 7 10.83 7 10C7 9.17 7.67 8.5 8.5 8.5C9.33 8.5 10 9.17 10 10C10 10.83 9.33 11.5 8.5 11.5ZM15.5 11.5C14.67 11.5 14 10.83 14 10C14 9.17 14.67 8.5 15.5 8.5C16.33 8.5 17 9.17 17 10C17 10.83 16.33 11.5 15.5 11.5Z"
      fill={color}
    />
  </svg>
);

export default SupportIcon;
